import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { cn } from '../lib/cn';

export function useCopy(timeout = 1500) {
  const [copied, setCopied] = useState(false);
  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), timeout);
      return true;
    } catch {
      return false;
    }
  };
  return { copied, copy };
}

export function CodeBlock({ code, label, copyable, className }: { code: string; label?: string; copyable?: boolean; className?: string }) {
  const { copied, copy } = useCopy();
  return (
    <div className={cn('overflow-hidden rounded-md border border-line bg-canvas', className)}>
      {(label || copyable) && (
        <div className="flex items-center justify-between border-b border-line px-3 py-1.5">
          <span className="label">{label}</span>
          {copyable && (
            <button
              type="button"
              onClick={() => void copy(code)}
              className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-2xs text-muted hover:bg-raised hover:text-ink"
              aria-label={copied ? 'Copied' : `Copy ${label ?? 'code'}`}
            >
              {copied ? <Check className="h-3 w-3 text-ok" aria-hidden /> : <Copy className="h-3 w-3" aria-hidden />}
              {copied ? 'Copied' : 'Copy'}
            </button>
          )}
        </div>
      )}
      <pre className="overflow-x-auto p-3 font-mono text-xs leading-relaxed text-ink">
        <code>{code}</code>
      </pre>
    </div>
  );
}
